export const ToolsAndUtilitiesIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99967 15.1668H9.99967C13.333 15.1668 14.6663 13.8335 14.6663 10.5002V6.50016C14.6663 3.16683 13.333 1.8335 9.99967 1.8335H5.99967C2.66634 1.8335 1.33301 3.16683 1.33301 6.50016V10.5002C1.33301 13.8335 2.66634 15.1668 5.99967 15.1668Z"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3799 12.8329V10.2329"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3799 5.4665V4.1665"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3808 8.93346C11.3381 8.93346 12.1141 8.15742 12.1141 7.20013C12.1141 6.24284 11.3381 5.4668 10.3808 5.4668C9.4235 5.4668 8.64746 6.24284 8.64746 7.20013C8.64746 8.15742 9.4235 8.93346 10.3808 8.93346Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.62012 12.8332V11.5332"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.62012 6.7665V4.1665"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.62005 11.5331C6.57735 11.5331 7.35339 10.757 7.35339 9.79974C7.35339 8.84245 6.57735 8.06641 5.62005 8.06641C4.66276 8.06641 3.88672 8.84245 3.88672 9.79974C3.88672 10.757 4.66276 11.5331 5.62005 11.5331Z"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
